import "./Palomino.module.css";
import Header from "@/reusable_sections/Header";
import HeroShowcase from "./sections/HeroShowcase";
import AdventureNatureExperience from "./sections/AdventureNatureExperience";
import HolisticWellness from "./sections/HolisticWellness";
import ExclusiveExperiences from "./sections/ExclusiveExperiences";
import SignaturePartnerships from "./sections/SignaturePartnerships";
import ExperienceInquiry from "./sections/ExperienceInquiry";
import Footer from "@/reusable_sections/Footer";
export default function PalominoPage() {
  return <div>
      <Header />
      <HeroShowcase />
      <HolisticWellness />
      <AdventureNatureExperience />
      <ExclusiveExperiences />
      <SignaturePartnerships />
      <ExperienceInquiry />
      <Footer />
    </div>;
}